<template>
  <div>
    <v-card-text class="d-flex flex-column align-center pa-0">
      <v-icon color="primary darken-1 mb-4" class="xxl-icon mb-4">mdi-check-circle-outline</v-icon>
      <div class="text-h5 font-weight-bold primary--text text--darken-1 text-center" style="line-height: 1.6rem">{{ $t('message.agentSignUpSuccessMessage') }}</div>
      <div class="email-us--wrapper d-flex flex-column align-center px-8 py-4 rounded-lg mb-6 mt-8">
        <v-icon x-large color="primary darken-1" class="mb-2">mdi-email-outline</v-icon>
        <p class="text-center">
          {{ $t('message.emailCustomerSupportForQueries') }}
          <a :href="`mailto:${customerServiceEmail}`">{{ customerServiceEmail }}</a>
        </p>
      </div>
    </v-card-text>
    <v-card-actions class="d-flex flex-column w-80 ma-auto">
      <v-btn color="primary" class="mb-4 rounded-pill green-gradient-right text-capitalize override-disabled-styles w-100" @click="$emit('refresh')">
        {{ $t('button.backToHome') }}
      </v-btn>
    </v-card-actions>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  computed: {
    ...mapState('auth', ['currentUser']),
    ...mapGetters('page', ['customerServiceEmail'])
  }
}
</script>

<style lang="scss">
.xxl-icon {
  font-size: 7rem !important;
}

.email-us--wrapper {
  border: 1px solid var(--v-primary-lighten1);
  max-width: 20rem;
}
</style>
